import { useAuth } from '../../../hooks/useAuth';
import { useTheme } from '../../../hooks/useTheme';

import { ReactComponent as Back } from '../../../icons/back.svg';
import { ReactComponent as Facebook } from '../../../icons/facebook.svg';
import { ReactComponent as Google } from '../../../icons/google.svg';
import { ReactComponent as Password } from '../../../icons/password.svg';
import { ReactComponent as User } from '../../../icons/user.svg';

import './auth-layout.scss';

import { Button } from '../../common/button/Button';
import Form from '../../common/form/Form';
import { Input } from '../../common/input/Input';

const AuthLayout = ({
  title,
  description,
  submitText,
  actionText,
  actionDescription,
  showForgotPassword,
  onBackPressed,
  onSubmit,
  onActionClick,
  onGoogleActionClick,
  onFacebookActionClick,
  onForgotPasswordClick
}) => {
  const { getThemeVariable } = useTheme();
  const { formData, setFormData, loading } = useAuth();
  const textColor = '#d0d0d0';

  const handleOnSubmit = () => {
    onSubmit(formData);
  };

  const handleOnInputChange = (data) => {
    const { name, value } = data;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <div className="auth-layout">
      <div className="auth-layout__back" onClick={onBackPressed}>
        <Back width={24} height={24} style={{ color: textColor }} />
      </div>
      <div className="auth-layout__title">
        <span>{title}</span>
        <span>{description}</span>
      </div>
      <div className="auth-layout__content">
        <Form
          onSubmit={loading ? () => {} : handleOnSubmit}
          data={formData}
          className="auth-layout__form"
        >
          <Input
            type="text"
            name="username"
            placeholder="Email/Username"
            required
            value={formData?.username}
            onChange={handleOnInputChange}
            Icon={User}
            filled
          />
          <Input
            type="password"
            name="password"
            placeholder="Password"
            required
            value={formData?.password}
            onChange={handleOnInputChange}
            Icon={Password}
            filled
          />
          <Button type="submit" loading={loading}>
            {submitText}
          </Button>
        </Form>
        {showForgotPassword && (
          <span
            style={{ color: textColor }}
            className="auth-layout__forgot"
            onClick={() => onForgotPasswordClick(formData?.username)}
          >
            Forgot Password
          </span>
        )}
        <div
          className="auth-layout__action"
          style={{ marginTop: showForgotPassword ? '0' : '24px' }}
        >
          <span style={{ color: textColor }}>{actionDescription}</span>
          <span style={{ color: getThemeVariable('accent-primary') }} onClick={onActionClick}>
            {actionText}
          </span>
        </div>
        <div className="auth-layout__connect-with">
          <div style={{ background: '#777777' }} />
          <span style={{ color: textColor }}> OR CONNECT WITH</span>
          <div style={{ background: '#777777' }} />
        </div>
        <div className="auth-layout__firebase">
          <Google width={48} height={48} onClick={onGoogleActionClick} />
          <Facebook width={48} height={48} onClick={onFacebookActionClick} />
        </div>
        <div className="auth-layout__footer">
          <span style={{ color: textColor }}>Terms &amp; Conditions &amp; Privacy Policy</span>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
